var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "session-list-item ui-elevation-1 panel" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "session-list-item__content" },
      [
        _c("dynamic-duration", {
          staticClass: "ui-display-2",
          attrs: { duration: _vm.session.duration },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "session-list-item__footer" }, [
      _c("div", [
        _c("div", { staticClass: "ui-caption" }, [_vm._v("Start time")]),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm._f("date")(_vm.session.start, "HH:mm")))]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "ui-caption" }, [_vm._v("Client")]),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.session.client))]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "session-list-item__header" }, [
      _c("i", { staticClass: "fa fa-stream" }),
      _vm._v(" "),
      _c("div", { staticClass: "ui-subheading" }, [_vm._v("RTMP")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }